import { styled } from "@mui/material"
import { Link as LinkRRD } from "react-router-dom"

const Link = styled(LinkRRD)(({ theme }) => ({
  textDecoration: "none",

  color: theme.palette.text.primary
}))
export default Link
